import PureCounter from '@srexi/purecounterjs';
import { crash1, crash2, crash3, crash4, crash5, crash6 } from './main.js';

document.addEventListener('DOMContentLoaded', ()=>{
  document.getElementById('loading').style.display = 'none';
})

function showMusicCard() {
  let container = document.createElement('div');
  let mainText = document.createElement('p');
  let subContainer = document.createElement('div');
  let checkboxText = document.createElement('p');
  let checkbox = document.createElement('Input');
  let label = document.createElement('label');
  let span = document.createElement('span');
  checkbox.setAttribute("type", "checkbox");
  let button = document.createElement('BUTTON');

  mainText.textContent = 'Zum imersiven Erlebnis der Website wird auch Audio verwendet. Schalten Sie bitte den Ton an.'
  container.classList.add('musik-container');

  checkboxText.textContent='🔊';
  checkbox.checked = true;
  button.textContent='Weiter';
  button.addEventListener('click', playAudio);

  subContainer.appendChild(checkboxText);
  label.appendChild(checkbox);
  label.appendChild(span);
  subContainer.appendChild(label);
  subContainer.appendChild(button);
  container.appendChild(mainText);
  container.appendChild(subContainer);
  document.body.appendChild(container);
}
showMusicCard();

function playAudio() {
  if(document.querySelector('input[type=checkbox]').checked){
    document.getElementById('myAudio').play();
  }
  document.querySelector('.musik-container').classList.add('fade-out');
  document.querySelector('.musik-container').addEventListener('animationend', () => {
    document.querySelector('.musik-container').remove();
  })
}


const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        console.log(entry);
        if (entry.isIntersecting){
            entry.target.classList.add('show');
        }
    });
});

const hiddenElements = document.querySelectorAll('.hidden');
hiddenElements.forEach((el) => observer.observe(el));

new PureCounter({
    // Setting that can't' be overriden on pre-element
    selector: ".purecounter", // HTML query selector for spesific element

    // Settings that can be overridden on per-element basis, by `data-purecounter-*` attributes:
    start: 0, // Starting number [uint]
    end: 100, // End number [uint]
    duration: 1, // The time in seconds for the animation to complete [seconds]
    delay: 10, // The delay between each iteration (the default of 10 will produce 100 fps) [miliseconds]
    once: true, // Counting at once or recount when the element in view [boolean]
    pulse: false, // Repeat count for certain time [boolean:false|seconds]
    decimals: 0, // How many decimal places to show. [uint]
    legacy: true, // If this is true it will use the scroll event listener on browsers
    filesizing: false, // This will enable/disable File Size format [boolean]
    currency: false, // This will enable/disable Currency format. Use it for set the symbol too [boolean|char|string]
    formater: "us-US", // Number toLocaleString locale/formater, by default is "en-US" [string|boolean:false]
    separator: true, // This will enable/disable comma separator for thousands. Use it for set the symbol too [boolean|char|string]
});

const radioInputs = document.querySelectorAll('.timeline input[type="radio"]');
const crashImage = document.getElementById('crash-image');

radioInputs.forEach(function(radioInput) {
  radioInput.addEventListener('change', function(event) {
    // Hier kannst du den Code für den Event-Handler einfügen
    console.log('Radio-Input:', event.target.value);

    if (event.target.value == 1) {
      crashImage.src = crash1;
    }

    if (event.target.value == 2) {
      crashImage.src = crash2;
    }

    if (event.target.value == 3) {
      crashImage.src = crash3;
    }

    if (event.target.value == 4) {
      crashImage.src = crash4;
    }

    if (event.target.value == 5) {
      crashImage.src = crash5;
    }

    if (event.target.value == 6) {
      crashImage.src = crash6;
    }

  });
});